<template>
    <div :class="amount == 2 ? 'col-2' : 'col-3'">
        <p class="code">{{steel.name}}</p>
        <h4>{{steel.type}}</h4>
        <table class="table">
            <tbody>
            <tr>
                <th>C</th>
                <td>{{ c[0] }}</td>
                <td>{{ c[1] }}</td>
                <td>{{ c[2] }}</td>
            </tr>
            <tr>
                <th>Si</th>
                <td>{{ si[0] }}</td>
                <td>{{ si[1] }}</td>
                <td>{{ si[2] }}</td>
            </tr>
            <tr>
                <th>Mn</th>
                <td>{{ mn[0] }}</td>
                <td>{{ mn[1] }}</td>
                <td>{{ mn[2] }}</td>
            </tr>
            <tr>
                <th>Co</th>
                <td>{{ co[0] }}</td>
                <td>{{ co[1] }}</td>
                <td>{{ co[2] }}</td>
            </tr>
            <tr>
                <th>Cr</th>
                <td>{{ cr[0] }}</td>
                <td>{{ cr[1] }}</td>
                <td>{{ cr[2] }}</td>
            </tr>
            <tr>
                <th>Mo</th>
                <td>{{ mo[0] }}</td>
                <td>{{ mo[1] }}</td>
                <td>{{ mo[2] }}</td>
            </tr>
            <tr>
                <th>Ni</th>
                <td>{{ ni[0] }}</td>
                <td>{{ ni[1] }}</td>
                <td>{{ ni[2] }}</td>
            </tr>
            <tr>
                <th>V</th>
                <td>{{ v[0] }}</td>
                <td>{{ v[1] }}</td>
                <td>{{ v[2] }}</td>
            </tr>
            <tr>
                <th>W</th>
                <td>{{ w[0] }}</td>
                <td>{{ w[1] }}</td>
                <td>{{ w[2] }}</td>
            </tr>
            </tbody>
        </table>

        <p class="clr_gray">{{steel.overig}}</p>

        <div class="rating-box">
            <div class="rating-sm-box">
                <h6>Verspaanbaarheid</h6>
                <div class="rating-circles">
                    <div class="rating-cirle" v-bind:class="{active: steel.verspaanbaarheid > 0}"></div>
                    <div class="rating-cirle" v-bind:class="{active: steel.verspaanbaarheid > 20}"></div>
                    <div class="rating-cirle" v-bind:class="{active: steel.verspaanbaarheid > 40}"></div>
                    <div class="rating-cirle" v-bind:class="{active: steel.verspaanbaarheid > 60}"></div>
                    <div class="rating-cirle" v-bind:class="{active: steel.verspaanbaarheid > 80}"></div>
                </div>
            </div>
            <div class="rating-sm-box">
                <h6>Taaiheid</h6>
                <div class="rating-circles">
                    <div class="rating-cirle" v-bind:class="{active: steel.taaiheid > 0}"></div>
                    <div class="rating-cirle" v-bind:class="{active: steel.taaiheid > 20}"></div>
                    <div class="rating-cirle" v-bind:class="{active: steel.taaiheid > 40}"></div>
                    <div class="rating-cirle" v-bind:class="{active: steel.taaiheid > 60}"></div>
                    <div class="rating-cirle" v-bind:class="{active: steel.taaiheid > 80}"></div>
                </div>
            </div>
            <div class="rating-sm-box">
                <h6>Slijtvastheid</h6>
                <div class="rating-circles">
                    <div class="rating-cirle" v-bind:class="{active: steel.slijtvastheid > 0}"></div>
                    <div class="rating-cirle" v-bind:class="{active: steel.slijtvastheid > 20}"></div>
                    <div class="rating-cirle" v-bind:class="{active: steel.slijtvastheid > 40}"></div>
                    <div class="rating-cirle" v-bind:class="{active: steel.slijtvastheid > 60}"></div>
                    <div class="rating-cirle" v-bind:class="{active: steel.slijtvastheid > 80}"></div>
                </div>
            </div>
            <div class="rating-sm-box">
                <h6>Maatvastheid</h6>
                <div class="rating-circles">
                    <div class="rating-cirle" v-bind:class="{active: steel.maatvastheid > 0}"></div>
                    <div class="rating-cirle" v-bind:class="{active: steel.maatvastheid > 20}"></div>
                    <div class="rating-cirle" v-bind:class="{active: steel.maatvastheid > 40}"></div>
                    <div class="rating-cirle" v-bind:class="{active: steel.maatvastheid > 60}"></div>
                    <div class="rating-cirle" v-bind:class="{active: steel.maatvastheid > 80}"></div>
                </div>
            </div>
            <div class="rating-sm-box">
                <h6>Corrosiebestendig</h6>
                <div class="rating-circles">
                    <div class="rating-cirle" v-bind:class="{active: steel.corrosiebestendigheid > 0}"></div>
                    <div class="rating-cirle" v-bind:class="{active: steel.corrosiebestendigheid > 20}"></div>
                    <div class="rating-cirle" v-bind:class="{active: steel.corrosiebestendigheid > 40}"></div>
                    <div class="rating-cirle" v-bind:class="{active: steel.corrosiebestendigheid > 60}"></div>
                    <div class="rating-cirle" v-bind:class="{active: steel.corrosiebestendigheid > 80}"></div>
                </div>
            </div>
        </div>
        <a :href="'/staalwijzer/detail/'+steel.slug" class="btn_blue">MEER INFO</a>
    </div>
</template>

<script>
    export default {
        props: [
            'steel',
            'amount'
        ],
        data: function() {
            return {
                c  : this.getArrayValueOfAttribute(this.steel.c),
                si : this.getArrayValueOfAttribute(this.steel.si),
                mn : this.getArrayValueOfAttribute(this.steel.mn),
                co : this.getArrayValueOfAttribute(this.steel.co),
                cr : this.getArrayValueOfAttribute(this.steel.cr),
                mo : this.getArrayValueOfAttribute(this.steel.mo),
                ni : this.getArrayValueOfAttribute(this.steel.ni),
                v  : this.getArrayValueOfAttribute(this.steel.v),
                w  : this.getArrayValueOfAttribute(this.steel.w),
            }
        },
        methods: {
            getArrayValueOfAttribute: function(value) {
                if (value == "0") {
                    return ["", "", ""];
                } else if (value.includes("≤")) {
                    return ["", "≤", value.replace("≤", "").trim()];
                } else if (value.split("-").length == 1) {
                    return ["", "", value.split("-")[0].trim()];
                } else {
                    return [value.split("-")[0].trim(), "-", value.split("-")[1].trim()]
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/steelfilter/compare/item.vue